import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';
import { ProductViewConfigurator } from '~/types/configurator';

let label;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [configuratorChoices.colors.brown],
            detailsModalLabel: 'Color options:',
            hideOnProductPage: true,
        },
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Select Material',
            choices: [
                {
                    label: (label = 'Compostable'),
                    detailsModalLabel: label,
                    value: 'compostable',
                    description: (description =
                        'A low barrier compostable option for those who will be consuming your product quickly, this bag does not have sealing properties or a degassing valve. Please note, the tin tie must be removed before composting.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Material options:',
            hideOnProductPage: true,
        },
    ],
} as ProductViewConfigurator;
